/* NYM reveal motion — progressive enhancement only.
   Adds .nym-motion to <html>, then reveals [data-nym-reveal] elements
   as they enter the viewport. Without JS everything is already visible. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('nym-motion');

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function observeAll(root) {
    root.querySelectorAll('[data-nym-reveal]:not(.is-revealed)').forEach(function (el) {
      io.observe(el);
    });
  }

  observeAll(document);
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
})();
